import { chargersListDefaultSorting } from '../components/boardTable/BoardsList'
import { SELECTION_LIMIT } from '../constants/boards'
import * as _ from 'lodash'

const SELECTION_LIMIT_MESSAGE = `Selection limit reached. You can select up to ${SELECTION_LIMIT} items at a time. Please refine your selection or filters to proceed.`

const initListState = {
  isFetching: false,
  forceUpdate: false,
  page_token: 0,
  page_size: 10,
  filter: null,
  sorting: null,
  totalCount: 0,
  data: [],
  selectedDataIds: [],
  selectedChipIds: [],
  excludedDataIds: [],
  selectAll: false,
  isExporting: false,
  selectionLimitError: null
}

function ssplists (state = {}, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return {}
    case 'INIT_SSPLIST': {
      // TODO: refactor later!!!
      if (!state[action.id]) {
        return Object.assign({}, state, {
          [action.id]: {
            ...initListState,
            page_size: action.defaultPageSize,
            sorting: action.defaultSorting,
            forceUpdate: true
          }
        })
      }

      const sspListInitState = {
        ...state[action.id],
        page_size: action.defaultPageSize,
        forceUpdate: true,
        isExporting: false
      }
      if (!state[action.id].sorting) {
        sspListInitState.sorting = action.defaultSorting
      }
      return Object.assign({}, state, { [action.id]: sspListInitState })
    }
    case 'LIST_REQUEST':
      return Object.assign({}, state, { [action.id]: { ...state[action.id], isFetching: true, forceUpdate: false, data: [] } })
    case 'LIST_REQUEST_SUCCESS':
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          isFetching: false,
          data: action.data,
          forceUpdate: false
        }
      })
    case 'LIST_REQUEST_ERROR':
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          isFetching: false,
          error: action.error,
          forceUpdate: false
        }
      })
    case 'CHANGE_PAGE_OR_SIZE':
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          page_token: action.page_token,
          page_size: action.page_size
        }
      })
    case 'CHANGE_FILTER':
      return Object.assign({}, state, { [action.id]: { ...state[action.id], filter: action.filter, page_token: 0, selectionLimitError: null } })
    case 'CHANGE_SORTING':
      return Object.assign({}, state, { [action.id]: { ...state[action.id], sorting: action.sorting, page_token: 0 } })
    case '@@router/LOCATION_CHANGE': {
      const pathname = action.payload.pathname
      const stateToModify = {}
      if (!pathname.includes('chargers')) {
        if (state.chargersList) {
          stateToModify.chargersList = {
            ...state.chargersList,
            sorting: chargersListDefaultSorting,
            filter: null
          }
        }
      }
      return _.size(stateToModify) ? Object.assign({}, state, stateToModify) : state
    }
    case 'SET_TOTAL_COUNT':
      return Object.assign({}, state, { [action.id]: { ...state[action.id], totalCount: action.count } })
    case 'SET_FORCE_UPDATE':
      return Object.assign({}, state, { [action.id]: { ...state[action.id], forceUpdate: true } })
    case 'SSP_TOGGLE_SELECT_ALL': {
      const currentState = state[action.id]
      const hasAnySelection = currentState.selectAll || currentState.selectedDataIds.length > 0

      if (hasAnySelection) {
        return Object.assign({}, state, {
          [action.id]: {
            ...currentState,
            selectAll: false,
            selectedDataIds: [],
            selectedChipIds: [],
            excludedDataIds: [],
            selectionLimitError: null
          }
        })
      }

      if (currentState.totalCount > SELECTION_LIMIT) {
        return Object.assign({}, state, {
          [action.id]: { ...currentState, selectionLimitError: SELECTION_LIMIT_MESSAGE }
        })
      }

      return Object.assign({}, state, {
        [action.id]: {
          ...currentState,
          selectAll: true,
          excludedDataIds: [],
          selectionLimitError: null
        }
      })
    }
    case 'SSP_DESELECT_ALL':
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          selectAll: false,
          selectedDataIds: [],
          selectedChipIds: [],
          excludedDataIds: [],
          selectionLimitError: null
        }
      })
    case 'SSP_TOGGLE_CURRENT_PAGE_SELECT_ALL': {
      if (action.selectedDataIds.length > SELECTION_LIMIT) {
        return Object.assign({}, state, {
          [action.id]: { ...state[action.id], selectionLimitError: SELECTION_LIMIT_MESSAGE }
        })
      }
      return Object.assign({}, state, {
        [action.id]: {
          ...state[action.id],
          selectAll: false,
          selectedDataIds: action.selectedDataIds,
          selectedChipIds: action.selectedChipIds,
          excludedDataIds: [],
          selectionLimitError: null
        }
      })
    }
    case 'SSP_SET_ACTIVE_ITEM': {
      const currentState = state[action.id]
      const deviceId = action.itemId
      const chipId = action.chipId

      if (currentState.selectAll) {
        const stateExcludedIds = currentState.excludedDataIds
        const isExcluded = stateExcludedIds.includes(deviceId)
        const excludedDataIds = isExcluded
          ? stateExcludedIds.filter(id => id !== deviceId)
          : [...stateExcludedIds, deviceId]

        return Object.assign({}, state, {
          [action.id]: { ...currentState, excludedDataIds, selectionLimitError: null }
        })
      }

      const stateDeviceIds = currentState.selectedDataIds
      const selected = stateDeviceIds.includes(deviceId)

      if (!selected && stateDeviceIds.length >= SELECTION_LIMIT) {
        return Object.assign({}, state, {
          [action.id]: { ...currentState, selectionLimitError: SELECTION_LIMIT_MESSAGE }
        })
      }

      const deviceIds = selected ? stateDeviceIds.filter(id => id !== deviceId) : [...stateDeviceIds, deviceId]

      const stateChipIds = currentState.selectedChipIds
      const selectedUuid = stateChipIds.includes(chipId)
      const deviceChipIds = selectedUuid ? stateChipIds.filter(id => id !== chipId) : [...stateChipIds, chipId]

      return Object.assign({}, state, {
        [action.id]: {
          ...currentState,
          selectedDataIds: deviceIds,
          selectedChipIds: deviceChipIds,
          selectionLimitError: null
        }
      })
    }
    case 'RECALCULATE_SORT_FILTER_WITH_COLUMNS': {
      const columns = action.columns
      columns.unshift('c_uuid')
      const stateById = state[action.id]
      const sortingToReturn = columns.includes(_.get(stateById, 'sorting.id'))
        ? stateById.sorting
        : { id: columns[0], desc: false }
      const filterToReturn = _.size(stateById.filter)
        ? stateById.filter.map((field) => columns.includes(field.id) ? field : null).filter((field) => !!field)
        : []
      return Object.assign({}, state, {
        [action.id]: {
          ...state[[action.id]],
          sorting: sortingToReturn,
          filter: filterToReturn,
          forceUpdate: true
        }
      })
    }
    case 'SSP_CLEAR_SELECTION_LIMIT_ERROR':
      return Object.assign({}, state, {
        [action.id]: { ...state[action.id], selectionLimitError: null }
      })
    case 'SET_LIST_EXPORTING': {
      const { payload: { id, isExporting } } = action

      return { ...state, [id]: { ...state[id], isExporting } }
    }
    default:
      return state
  }
}

export default ssplists
